<script>
  export let choices;
  export let value = "-1";
   $: valid=value !="-1"
</script>
<fieldset class={valid?"done":"todo"}>
<label>
  <slot />
  <select bind:value on:change>
    <option value="-1">scegli</option>
    {#each choices as { value, text }}
      <option {value}>{text}</option>
    {/each}
  </select>
</label>
</fieldset>
<style>
  fieldset {
        border-radius: 5px;
        background: #c4e7c3b9;
        margin: 1rem;
        padding: 1rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
        position: relative;
        border: 2px groove threedface;
        max-width: 80ch;
      }
  label {
    max-width: 60ch;
  }
  .done{
    background-color: azure;
  }
</style>
